<template>
    <div>
        <div class="index-title-tab">
            <img class="title-logo" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mainlogo.png" alt="">
            <div class="index-title-tabr">
                <div class="title-tab-box">
                    <div @click="gohome" @mousemove="moveLeft(34)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>首页</span>
                    </div>
                    <div @click="scrollToAnchor('#service')" @mousemove="moveLeft(120)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>业务范围</span>
                    </div>
                    <div @click="scrollToAnchor('#product')" @mousemove="moveLeft(230)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>知新SCRM</span>
                    </div>
                    <div @click="goeducation" @mousemove="moveLeft(320)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>教育</span>
                    </div>
    <!--                <div @mousemove="moveLeft(150)" @mouseleave="moveOutLeft" class="title-tab solutionDropdownShow">
                        <span>产品和解决方案</span>
                        <div class="solutionDropdown">
                            <div class="solutionDropdownBox">
                                   <div @click="goscrm" class="solutionDropdownBoxCBG tab2Show">
                                       <div class="solutionDropdownBoxC">
                                           <span>知新SCRM</span>
                                           <img class="tab-r show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tab-r.png" alt="">
                                           <img class="tab-r show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                                       </div>
                                   </div>
     &lt;!&ndash;                           <div class="solutionDropdownBoxCBG tab2Show">
                                    <div @click="goretail" class="solutionDropdownBoxC">
                                        <span>零售</span>
                                        <img class="tab-r show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tab-r.png" alt="">
                                        <img class="tab-r show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                                    </div>
                                    <div class="solutionDropdownBox-tab2">
                                        <div class="solutionDropdownBox-tab">
                                            <div @click="goretailMiddleGround" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC">全渠道业务中台解决方案</div>
                                            </div>
                                            <div @click="goretailDigitization" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC">数字化营销解决方案</div>
                                            </div>
                                            <div @click="goretailMarketing" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC" style="border-bottom: none">智能巡店访销解决方案</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>&ndash;&gt;
                                <div class="solutionDropdownBoxCBG tab2Show">
                                    <div @click="goeducation" class="solutionDropdownBoxC" style="border-bottom: none;">
                                        <span>教育</span>
                                        <img class="tab-r show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/tab-r.png" alt="">
                                        <img class="tab-r show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                                    </div>
             &lt;!&ndash;                       <div class="solutionDropdownBox-tab2">
                                        <div class="solutionDropdownBox-tab">
                                            <div @click="goeducationRecruit" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC">智能招生</div>
                                            </div>
                                            <div @click="goeducationTeaching" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC">智能教学</div>
                                            </div>
                                            <div @click="goeducationAdministration" class="solutionDropdownBox-tabCBG">
                                                <div class="solutionDropdownBox-tabC" style="border-bottom: none">智能管理</div>
                                            </div>
                                        </div>
                                    </div>&ndash;&gt;
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <div @click="gocooperation" @mousemove="moveLeft(408)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>合作案例</span>
                    </div>
                    <div @click="gowe" @mousemove="moveLeft(508)" @mouseleave="moveOutLeft" class="title-tab">
                        <span>关于我们</span>
                    </div>
                    <div class="title-tab-line" :style="'left: ' +left+'px'"></div>
                </div>
                <div @click="popshow = true" :class="isHome?'home-triala':'home-triala2'">产品试用</div>
            </div>
        </div>
        <div v-if="popshow" class="pop-bg">
            <div class="pop">
                <img class="pop-logo" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t1.png" alt="">
                <div class="pop-title">产品试用请联系</div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t2.png" alt="">
                        <div>手机号：</div>
                    </div>
                    <div class="pop-title2-box-r">15900622304</div>
                </div>
                <div class="pop-title2-box" style="margin-bottom: 38px;">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">18862561723</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" style="width: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mailbox.png" alt="">
                        <div>邮箱：</div>
                    </div>
                    <div class="pop-title2-box-r">jenny.wang@unishining.com</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">Diana.wu@unishining.com</div>
                </div>
                <div @click="popshow = false" class="pop-out">知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopBar",
        data:vm=>{
            return{
                popshow:false,
                isHome:true,//是否是首页
                left:34,//移动的px
                cleft:34,//当前页面的移动px保存
            }
        },
        mounted() {
            // console.log(this.$route.path,'WATCHrOUTE');
        },
        methods:{
            scrollToAnchor(id) {
                console.log(this.$route.path);
                if(this.$route.path == '/'){
                    document.querySelector(id).scrollIntoView(true);
                }else {
                    if(id == '#service'){
                        this.$router.push('/?st=1')
                    }else {
                        this.$router.push('/?st=2')
                    }
                }
            },
            gohome(){
                this.cleft =  34
                this.$router.push('/')
            },
            gowe(){
                this.cleft =  508
                this.$router.push('/we')
            },
            gocooperation(){
                this.cleft =  408
                this.$router.push('/cooperation')
            },
            goretail(){
                this.cleft =  150
                this.$router.push('/retail')
            },
            goretailMarketing(){
                this.cleft =  150
                this.$router.push('/retailMarketing')
            },
            goretailDigitization(){
                this.cleft =  150
                this.$router.push('/retailDigitization')
            },
            goretailMiddleGround(){
                this.cleft =  150
                this.$router.push('/retailMiddleGround')
            },
            goeducation(){
                this.cleft =  320
              // this.$router.push('/education')
                window.location.href = 'https://www.zhixinguo8.com/#/'
            },
            goscrm(){
                this.cleft =  150
                this.$router.push('/scrm')
            },
            goeducationAdministration(){
                this.cleft =  150
                this.$router.push('/educationAdministration')
            },
            goeducationTeaching(){
                this.cleft =  150
                this.$router.push('/educationTeaching')
            },
            goeducationRecruit(){
                this.cleft =  150
                this.$router.push('/educationRecruit')
            },
            moveLeft(left){//选中移动
                // console.log(111);
                this.left = left
            },
            moveOutLeft(){//选中移动
                // console.log(111);
                this.left = this.cleft
            }
        },
        watch:{
            '$route.path': function (newVal, oldVal) {
                // console.log(this.$route,'WATCHrOUTE');
                // console.log(33444,newVal);
                if(newVal == '/retail'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/educationRecruit'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/educationTeaching'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/educationAdministration'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/education'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/retailMarketing'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/retailDigitization'){
                    this.left =  150
                    this.cleft =  150
                }
                if(newVal == '/retailMiddleGround'){
                    this.left =  150
                    this.cleft =  150
                }

                if(newVal == '/'){
                    this.left =  34
                    this.cleft =  34
                }
                if(newVal == '/cooperation'){
                    this.left =  408
                    this.cleft =  408
                }
                if(newVal == '/we'){
                    this.left =  508
                    this.cleft =  508
                }
                if(newVal != '/'){
                    this.isHome = false
                }else {
                    this.isHome = true
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    .index-title-tab{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
        box-sizing: content-box;
        position: relative;
        z-index: 10;
        .title-logo{
            width: 151px;
        }
        .index-title-tabr{
            display: flex;
            align-items: center;
            .title-tab-box{
                position: absolute;
                right: 290px;
                display: flex;
                align-items: center;
                color:rgba(12,12,12,1);
                .title-tab{
                    position: relative;
                    margin-left: 30px;
                    cursor: pointer;
                    font-size: 18px;
                    color: #0C0C0C;
                }
                .solutionDropdownShow{
                    .solutionDropdown{
                        position: absolute;
                        z-index: 1;
                        top: 20px;
                        left: 0;
                        width: 100%;
                        padding-top: 20px;
                        height: 100px;
                        display: none;
                        .solutionDropdownBox{
                            width: 100%;
                            height: 88px;
                            background: rgba(255,255,255,.9);
                            box-sizing: border-box;
                            .solutionDropdownBoxCBG{
                                width: 100%;
                                height: 44px;
                                padding: 0 10px;
                                box-sizing: border-box;
                                .show{
                                    display: block;
                                }
                                .show2{
                                    display: none;
                                }
                                .solutionDropdownBoxC{
                                    height: 100%;
                                    width: 100%;
                                    border-bottom: 1px solid rgba(84, 84, 84, .19);
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 16px;
                                    .tab-r{
                                        width: 10px;
                                        margin-left: 5px;
                                    }
                                }
                            }
                            .solutionDropdownBoxCBG:hover{
                                color: #fff;
                                background: #DC0616;
                            }
                            .solutionDropdownBoxCBG:hover .show{
                                display: none;
                            }
                            .solutionDropdownBoxCBG:hover .show2{
                                display: block;
                            }
                            .tab2Show:hover .solutionDropdownBox-tab2{
                                display: block;
                            }
                            .solutionDropdownBox-tab2{
                                position: absolute;
                                display: none;
                                left: 100%;
                                top: 20px;
                                width: 177px;
                                height: 130px;
                                padding-left: 10px;
                                .solutionDropdownBox-tab{
                                    width: 177px;
                                    height: 100%;
                                    background: rgba(255,255,255,.9);
                                    .solutionDropdownBox-tabCBG{
                                        width: 100%;
                                        height: 44px;
                                        padding: 0 10px;
                                        box-sizing: border-box;
                                        color: #020C19;
                                        .solutionDropdownBox-tabC{
                                            height: 100%;
                                            width: 100%;
                                            border-bottom: 1px solid rgba(84, 84, 84, .19);
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            font-size: 14px;
                                        }
                                    }
                                    .solutionDropdownBox-tabCBG:hover{
                                        color: #fff;
                                        background: #DC0616;
                                    }
                                }
                            }
                        }
                    }
                }
                .solutionDropdownShow:hover .solutionDropdown{
                    display: block;
                }
                .title-tab-line{
                    width: 25px;
                    height: 6px;
                    background: #DC0616;
                    -webkit-border-radius: 6px;
                    -moz-border-radius: 6px;
                    border-radius: 6px;
                    position: absolute;
                    bottom: -10px;
                    transition: all .2s linear;
                }
                .tab-sele{
                    font-weight: bold;
                }
            }
            .home-triala{
                position: absolute;
                z-index: 1;
                right: 0;
                width: 102px;
                height: 37px;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: #0C0C0C;
                -webkit-border-radius: 20px;
                -moz-border-radius: 20px;
                border-radius: 20px;
                cursor: pointer;
            }
            .home-triala2{
                position: absolute;
                z-index: 1;
                right: 0;
                width: 102px;
                height: 37px;
                background: #DC0616;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: #fff;
                -webkit-border-radius: 20px;
                -moz-border-radius: 20px;
                border-radius: 20px;
                cursor: pointer;
            }
            .home-triala2:hover{
                box-shadow: 0px 0px 10px 2px #DC0616;
                transition: all .2s linear;
            }
            .home-triala:hover{
                box-shadow: 0px 0px 10px 2px #ffffff;
                transition: all .2s linear;
            }

        }

    }

    .pop-bg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 99999;
        background: rgba(0,0,0,.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .pop{
            width: 395px;
            height: 502px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .pop-logo{
                margin-bottom: 17px;
            }
            .pop-title{
                font-size: 20px;
                color: #000000;
                margin-bottom: 55px;
            }
            .pop-title2-box{
                display: flex;
                width: 350px;
                .pop-title2-box-l{
                    width: 96px;
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    .pop-logo2{
                        margin-right: 11px;
                    }
                }
                .pop-title2-box-r{
                    color: #B10515;
                    font-size: 18px;
                }
            }
            .pop-out{
                width: 172px;
                height: 45px;
                background: #B10515;
                border-radius: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-size: 16px;
                cursor: pointer;
                margin-top: 70px;
            }
        }
    }
</style>